import type { FaireProductEntity } from "../../entity_types/product";

export const p_fb52hxgf7x: FaireProductEntity = {
  token: "p_fb52hxgf7x",
  type: "product",
  name: "To-Do List Notepad | Organization Stationery",
  brandName: "Hay Design Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/327178a4dc976205111f865c35ea65497a34798f524acd5f41e83aae575e0149.jpeg",
  priceDollars: 3,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/170cf08fc0afe1eae2658e44ef885770ac0bdb8d018e171b2b682b7328ee74c4.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
